module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray-f47a1b79bc66c2bf4b44b251545950f1.png";